import { motion } from 'framer-motion';

interface HeroContentProps {
  name: string;
  title: string;
  tagline: string;
  description: string;
}

const HeroContent = ({ name, title, tagline, description }: HeroContentProps) => {
  return (
    <div className="text-center max-w-4xl mx-auto mb-12">
      <motion.div
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6, delay: 0.2 }}
      >
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-4 drop-shadow-lg">
          {name}
        </h1>
      </motion.div>

      <motion.div
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6, delay: 0.3 }}
      >
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-accent mb-4 glow-text">
          {title}
        </h2>
      </motion.div>

      <motion.div
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6, delay: 0.4 }}
      >
        <p className="text-xl md:text-2xl text-white/70 mb-6 font-medium">
          {tagline}
        </p>
      </motion.div>

      <motion.div
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6, delay: 0.5 }}
      >
        <p className="text-base md:text-lg text-white/60 leading-relaxed max-w-3xl mx-auto">
          {description}
        </p>
      </motion.div>
    </div>
  );
};

export default HeroContent;